import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  TextField,
  InputAdornment,
  TablePagination,
  Dialog,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  Tooltip,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import DeleteIcon from "@material-ui/icons/Delete";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import DateRangeIcon from "@material-ui/icons/DateRange";
import EventBusyIcon from "@material-ui/icons/EventBusy";
import MenuIcon from "@material-ui/icons/Menu";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import RestorePageIcon from "@material-ui/icons/RestorePage";
import ViewCompactIcon from "@material-ui/icons/ViewCompact";
import CloseIcon from "@material-ui/icons/Close";
import Menu from "@material-ui/core/Menu";

/* ------------------------- Importaciones internas ------------------------- */
import { api } from "../../../services/api";
import { handleGenericUpdate } from "../../../core/utils/handleGeneric";
import { exportarExcel } from "../../../core/utils/excelGeneric";
import ConfirmDialog from "../../../components/Dialogs/ConfirmDialog";
import ABMProveedorModal from "./adicionales/createProveedores";
import BotonGenerico from "../../../components/Button/Button";

/* --------------------------------- Estilos -------------------------------- */
const useStyles = makeStyles((theme) => ({
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  leftButtonContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  leftButton: {
    display: "flex",
    alignItems: "center",
    textTransform: "none",
    backgroundColor: "green",
    color: "white",
    "&:hover": {
      backgroundColor: "#388e3c",
    },
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
  },
  rightActionsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      justifyContent: "space-between",
    },
  },
  searchField: {
    marginRight: theme.spacing(2),
    width: "200px",
    [theme.breakpoints.down("xs")]: {
      width: "50%",
      marginBottom: theme.spacing(1),
    },
  },
  iconButtonsContainer: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-end",
      width: "100%",
    },
  },
  errorIcon: {
    color: "green",
    fontSize: "4rem",
    marginBottom: theme.spacing(2),
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    textAlign: "center",
  },
  dialogButtons: {
    justifyContent: "center",
  },
  greenButton: {
    color: "green",
    borderColor: "green",
    borderRadius: theme.shape.borderRadius,
    textTransform: "none",
  },
  menuIconButton: {
    color: theme.palette.primary.main,
  },
  menuItemIcon: {
    marginRight: theme.spacing(1),
  },
  greenIcon: {
    color: "green",
  },
  dateRangeFormContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  dateRangeFields: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    "& > *": {
      margin: theme.spacing(1),
      minWidth: "150px", // Asegura un ancho mínimo para alineación
    },
  },
  dateRangeButton: {
    marginTop: theme.spacing(2),
    alignSelf: "center", // Centrar el botón
  },
  greenBackg: {
    backgroundColor: "green",
    color: "white",
    "&:hover": {
      backgroundColor: "#388e3c",
    },
  },

  // Ancho máximo para el diálogo del modal
  dialogContentWide: {
    minWidth: "500px", // Añade un ancho mínimo de 500px
    maxWidth: "700px", // Ajusta a 700px para más espacio
    padding: theme.spacing(3), // Más espacio interno para mejor legibilidad
  },
  dialogTitleClos: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  // Para evitar el solapamiento del texto
  dialogTitleText: {
    marginRight: theme.spacing(3), // Separa el texto del ícono de cerrar
  },
}));

const Proveedores = () => {
  const classes = useStyles();
  const [dataEvents, setDataEvents] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [showHiddenRecords, setShowHiddenRecords] = useState(false);
  const [showDateRangeForm, setShowDateRangeForm] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [selectedProveedor, setSelectedProveedor] = useState(null);
  const [readOnlyDetail, setReadOnlyDetail] = useState(false);
  const [columnConfigOpen, setColumnConfigOpen] = useState(false);

  // ------------------ Estados de filtros ------------------
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedEstado, setSelectedEstado] = useState("");

  const [visibleColumns, setVisibleColumns] = useState({
    Estado: true,
    Rol: true,
    Nombres: true,
    Telefono: true,
    Email: true,
    Direccion: true,
    FechaRegistro: true,
    cuit: true,
    codigoPostal: false,
    pais: false,
    localidad: false,
    provincia: false,
    condicionFrenteAlIva: false,
    personaDeContacto: false,
  });

  const fetchData = async () => {
    try {
      const [proveedoresResponse, correosProveedoresResponse] = await Promise.all([
        api.proveedores.getAll(),
        api.correoProveedores.getAll(),
      ]);

      // Crear un mapa de correos agrupados por proveedor_id
      const correosPorProveedor = correosProveedoresResponse.reduce((acc, correo) => {
        const id = correo.proveedor_id;
        if (!acc[id]) acc[id] = [];
        acc[id].push({
          idemails: correo.idemails,
          proveedor_id: correo.proveedor_id,
          email: correo.email,
        });
        return acc;
      }, {});


      const proveedoresConCorreos = proveedoresResponse.map((proveedor) => ({
        ...proveedor,
        email: correosPorProveedor[proveedor.idProveedor] || [], // ahora es array de objetos
      }));

      // console.log("Proveedores con correos:", proveedoresConCorreos);

      setDataEvents(proveedoresConCorreos);
      setFilteredEvents(proveedoresConCorreos);

    } catch (error) {
      console.error("Error al cargar datos:", error.message);
    }
  };

  const visibleRows = filteredEvents.filter(
    (row) => (showHiddenRecords ? row.oculto : !row.oculto)
  );

  const coincideBusqueda = (event, text) => {
    const termino = (text || "").toLowerCase().trim();
    if (!termino) return true;

    return Object.entries(event).some(([key, value]) => {
      if (value == null) return false;

      if (key === "email" && Array.isArray(value)) {
        return value.some((correo) => {
          if (typeof correo === "string") {
            return correo.toLowerCase().includes(termino);
          }

          return (correo?.email || "").toLowerCase().includes(termino);
        });
      }

      if (Array.isArray(value)) {
        return value
          .map((item) => (typeof item === "object" ? JSON.stringify(item) : String(item)))
          .join(" ")
          .toLowerCase()
          .includes(termino);
      }

      return String(value).toLowerCase().includes(termino);
    });
  };


  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    let temp = [...dataEvents];

    // Filtrar por oculto
    temp = temp.filter((row) => (showHiddenRecords ? row.oculto : !row.oculto));

    // Filtrar por rango de fechas
    if (startDate) {
      temp = temp.filter((row) => new Date(row.fechaRegistro) >= new Date(startDate));
    }
    if (endDate) {
      temp = temp.filter((row) => new Date(row.fechaRegistro) <= new Date(endDate));
    }

    if (selectedEstado !== "") {
      temp = temp.filter((row) => row.Estado === selectedEstado);
    }

    // Filtro de búsqueda
    if (searchText) {
      temp = temp.filter((event) => coincideBusqueda(event, searchText));
    }

    const nuevoTemp = temp.reverse();

    setFilteredEvents(nuevoTemp);
    setPage(0);
  }, [dataEvents, searchText, startDate, endDate, showHiddenRecords, selectedEstado]);


  useEffect(() => {
    const visibleCount = filteredEvents.filter(
      (row) => showHiddenRecords ? row.oculto : !row.oculto
    ).length;

    if (page > 0 && page * rowsPerPage >= visibleCount) {
      setPage(Math.max(0, Math.ceil(visibleCount / rowsPerPage) - 1));
    }
  }, [filteredEvents, page, rowsPerPage, showHiddenRecords]);

  const handleSearchChange = (event) => {
    const text = event.target.value.toLowerCase();
    setSearchText(text);
    const filtered = dataEvents.filter((event) => coincideBusqueda(event, text));

    setFilteredEvents(filtered);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const handleMenuOpen = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const toggleHiddenRecords = () => {
    setShowHiddenRecords((prev) => !prev);
    handleMenuClose();
  };

  const exportToCSV = async () => {
    const columnas = [
      { key: 'Estado', label: 'Estado' },
      { key: 'Rol', label: 'Rol' },
      { key: 'ApellidoyNombre', label: 'Razón social' },
      { key: 'cuit', label: 'CUIT' },
      { key: 'condicionFrenteAlIva', label: 'Condición frente al IVA' },
      { key: 'Telefono', label: 'Teléfono' },
      { key: 'email', label: 'Email' },
      { key: 'Direccion', label: 'Dirección' },
      { key: 'codigoPostal', label: 'Código postal' },
      { key: 'pais', label: 'País' },
      { key: 'localidad', label: 'Localidad' },
      { key: 'provincia', label: 'Provincia' },
      { key: 'fechaRegistro', label: 'Fecha Registro' }
    ];

    const formatearDato = (key, valor) => {
      switch (key) {
        case 'Estado':
          return valor ? estadoCliente(valor) : 'Sin Estado';
        case 'Rol':
          return valor || 'Sin rol';
        case 'ApellidoyNombre':
          return valor || 'Sin razón social';
        case 'cuit':
          return valor || 'Sin CUIT';
        case 'condicionFrenteAlIva':
          return valor || 'Sin condición frente al IVA';
        case 'Telefono':
          return valor || 'Sin teléfono';
        case 'email':
          return Array.isArray(valor) && valor.length > 0
            ? valor
                .map((correo) => (typeof correo === 'string' ? correo : correo?.email))
                .filter(Boolean)
                .join('; ')
            : 'Sin correos';
        case 'Direccion':
          return valor || 'Sin dirección';
        case 'codigoPostal':
          return valor || 'Sin código postal';
        case 'pais':
          return valor || 'Sin país';
        case 'localidad':
          return valor || 'Sin localidad';
        case 'provincia':
          return valor || 'Sin provincia';
        case 'fechaRegistro':
          return valor || 'Fecha no disponible';
        default:
          return valor ?? '';
      }
    };

    const datosExcel = filteredEvents.map(row => {
      const fila = {};
      columnas.forEach(col => {
        fila[col.label] = formatearDato(col.key, row[col.key]);
      });
      return fila;
    });

    if (datosExcel.length > 0) {
      await exportarExcel('proveedores', datosExcel);
    }

    handleMenuClose();
  };

  const normalizarEstado = (estado) => {
    return (estado || "").toString().trim().toLowerCase();
  };

  const estadoCliente = (estado) => {
    switch (normalizarEstado(estado)) {
      case "activo":
        return "Activo";
      case "inactivo":
        return "Inactivo";

      default:
        return "Sin estado";
    }
  };

  const renderEstadoIcon = (estado) => {
    switch (normalizarEstado(estado)) {
      case "activo":
        return <CheckCircleIcon style={{ color: "green" }} />;
      case "inactivo":
        return <CancelIcon style={{ color: "red" }} />;

      default:
        return null;
    }
  };

  const formatearFechaCorta = (fecha) => {
    if (!fecha) return "";

    if (typeof fecha === "string" && /^\d{4}-\d{2}-\d{2}/.test(fecha)) {
      const [anio, mes, dia] = fecha.split("-");
      return `${dia}/${mes}/${anio.slice(-2)}`;
    }

    const parsedDate = new Date(fecha);
    if (Number.isNaN(parsedDate.getTime())) return fecha;

    return new Intl.DateTimeFormat("es-AR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    }).format(parsedDate);
  };

  const handleDateRangeClick = () => {
    setShowDateRangeForm(!showDateRangeForm);
  };

  const handleColumnConfigOpen = () => setColumnConfigOpen(true);
  const handleColumnConfigClose = () => setColumnConfigOpen(false);

  const handleColumnVisibilityChange = (column) => {
    setVisibleColumns((prev) => ({ ...prev, [column]: !prev[column] }));
  };

  const handleSuccess = () => {
    fetchData();
  };

  const handleOpenForm = () => {
    setReadOnlyDetail(false);
    setOpenForm(true);
    setSelectedProveedor(null);
  };
  const handleCloseForm = () => {
    setOpenForm(false);
    setReadOnlyDetail(false);
  };

  return (
    <div>
      <div className={classes.headerContainer}>
        <div className={classes.leftButtonContainer}>
          <BotonGenerico
            tipo="nuevo"
            text="Nuevo"
            onClick={handleOpenForm}
          />
          <ABMProveedorModal
            open={openForm}
            onClose={handleCloseForm}
            onSuccess={handleSuccess}
            proveedor={selectedProveedor}
            readOnly={readOnlyDetail}
          />
        </div>
        {showHiddenRecords && (
          <Typography variant="body1">
            Los proveedores solo pueden ser editados si fueron restaurados
          </Typography>
        )}
        <div className={classes.rightActionsContainer}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Buscar"
            value={searchText}
            onChange={handleSearchChange}
            className={classes.searchField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <div className={classes.iconButtonsContainer}>
            <IconButton color="primary" onClick={handleDateRangeClick}>
              {showDateRangeForm ? <EventBusyIcon /> : <DateRangeIcon />}
            </IconButton>
            <IconButton
              className={classes.menuIconButton}
              onClick={handleMenuOpen}
            >
              <MenuIcon className={classes.greenIcon} />
            </IconButton>
            <Menu
              anchorEl={menuAnchorEl}
              keepMounted
              open={Boolean(menuAnchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={toggleHiddenRecords}>
                <VisibilityOffIcon
                  className={`${classes.menuItemIcon} ${classes.greenIcon}`}
                />
                {showHiddenRecords ? "Ver registros activos" : "Ver registros ocultos"}
              </MenuItem>
              <MenuItem onClick={exportToCSV}>
                <RestorePageIcon
                  className={`${classes.menuItemIcon} ${classes.greenIcon}`}
                />
                Exportar Registros
              </MenuItem>
              <MenuItem onClick={handleColumnConfigOpen}>
                <ViewCompactIcon
                  className={`${classes.menuItemIcon} ${classes.greenIcon}`}
                />
                Configurar Columnas
              </MenuItem>
            </Menu>
          </div>
        </div>
      </div>

      {showDateRangeForm && (
        <div className={classes.dateRangeFormContainer}>
          <div className={classes.dateRangeFields}>
            <InputLabel>Desde:</InputLabel>
            <TextField variant="outlined" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
            <InputLabel>Hasta:</InputLabel>
            <TextField variant="outlined" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />

            <FormControl variant="outlined">
              <InputLabel>Estado</InputLabel>
              <Select
                value={selectedEstado}
                onChange={(e) => setSelectedEstado(e.target.value)}
                label="Estado"
              >
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="activo">Activo</MenuItem>
                <MenuItem value="inactivo">Inactivo</MenuItem>
              </Select>
            </FormControl>

          </div>
          <BotonGenerico color="primary" onClick={() => { setStartDate(""); setEndDate(""); setSelectedEstado(""); }} text="Borrar filtros" />
        </div>
      )}
      <Dialog
        open={columnConfigOpen}
        onClose={handleCloseDialog}
        classes={{ paper: classes.dialogContentWide }}
      >
        <DialogTitle className={classes.dialogTitleClos}>
          Configurar Columnas
          <IconButton
            onClick={handleColumnConfigClose}
            style={{ position: "absolute", right: 10, top: 10 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {Object.keys(visibleColumns).map((column) => (
            <div key={column} style={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                checked={visibleColumns[column]}
                onChange={() => handleColumnVisibilityChange(column)}
              />
              <Typography>{column}</Typography>
            </div>
          ))}
        </DialogContent>
      </Dialog>

      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {visibleColumns.Estado && (
                <TableCell align="left" className={classes.header}>
                  Estado
                </TableCell>
              )}
              {visibleColumns.Rol && (
                <TableCell align="center" className={classes.header}>
                  Rol
                </TableCell>
              )}
              {visibleColumns.Nombres && (
                <TableCell align="center" className={classes.header}>
                  Razón social
                </TableCell>
              )}
              {visibleColumns.cuit && (
                <TableCell align="center" className={classes.header}>
                  CUIT
                </TableCell>
              )}
              {visibleColumns.condicionFrenteAlIva && (
                <TableCell align="center" className={classes.header}>
                  Condición frente al IVA
                </TableCell>
              )}
              {visibleColumns.Telefono && (
                <TableCell align="center" className={classes.header}>
                  Teléfono
                </TableCell>
              )}
              {visibleColumns.Email && (
                <TableCell align="center" className={classes.header}>
                  Correo Electrónico
                </TableCell>
              )}
              {visibleColumns.Direccion && (
                <TableCell align="center" className={classes.header}>
                  Dirección
                </TableCell>
              )}
              {visibleColumns.codigoPostal && (
                <TableCell align="center" className={classes.header}>
                  Código postal
                </TableCell>
              )}
              {visibleColumns.pais && (
                <TableCell align="center" className={classes.header}>
                  País
                </TableCell>
              )}
              {visibleColumns.localidad && (
                <TableCell align="center" className={classes.header}>
                  Localidad
                </TableCell>
              )}
              {visibleColumns.provincia && (
                <TableCell align="center" className={classes.header}>
                  Provincia
                </TableCell>
              )}
              {visibleColumns.FechaRegistro && (
                <TableCell align="center" className={classes.header}>
                  Fecha
                </TableCell>
              )}
              <TableCell align="center" className={classes.header}>
                Opciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleRows.length > 0 ? (
              visibleRows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) // Paginación
                .map((row, index) => (
                  <TableRow key={`item-${index}`}>
                    {visibleColumns.Estado && (
                      <TableCell className={classes.estadoIcon}>
                        <Tooltip title={estadoCliente(row.Estado)} arrow>
                          <span>{renderEstadoIcon(row.Estado)}</span>
                        </Tooltip>
                      </TableCell>
                    )}
                    {visibleColumns.Rol && (
                      <TableCell align="center">{row.Rol}</TableCell>
                    )}
                    {visibleColumns.Nombres && (
                      <TableCell align="center">{row.ApellidoyNombre}</TableCell>
                    )}
                    {visibleColumns.cuit && (
                      <TableCell align="center">{row.cuit}</TableCell>
                    )}
                    {visibleColumns.condicionFrenteAlIva && (
                      <TableCell align="center">{row.condicionFrenteAlIva}</TableCell>
                    )}
                    {visibleColumns.Telefono && (
                      <TableCell align="center">{row.Telefono}</TableCell>
                    )}
                    {visibleColumns.Email && (
                      <TableCell align="center">
                        {Array.isArray(row.email) && row.email.length > 0 ? (
                          row.email.map((correoObj) => (
                            <div key={correoObj.idemails}>{correoObj.email}</div>
                          ))
                        ) : (
                          <em>Sin correos</em>
                        )}
                      </TableCell>
                    )}

                    {visibleColumns.Direccion && (
                      <TableCell align="center">{row.Direccion}</TableCell>
                    )}
                    {visibleColumns.codigoPostal && (
                      <TableCell align="center">{row.codigoPostal}</TableCell>
                    )}
                    {visibleColumns.pais && (
                      <TableCell align="center">{row.pais}</TableCell>
                    )}
                    {visibleColumns.localidad && (
                      <TableCell align="center">{row.localidad}</TableCell>
                    )}
                    {visibleColumns.provincia && (
                      <TableCell align="center">{row.provincia}</TableCell>
                    )}
                    {visibleColumns.FechaRegistro && (
                      <TableCell align="center">{formatearFechaCorta(row.fechaRegistro)}</TableCell>
                    )}
                    <TableCell align="center">
                      <IconButton onClick={() => {
                        setSelectedProveedor(row);
                        setReadOnlyDetail(showHiddenRecords);
                        setOpenForm(true);
                      }}>
                        <SearchIcon color="primary" />
                      </IconButton>
                      {!showHiddenRecords && (
                        <IconButton
                          onClick={() => handleOpenDialog(row)}
                          className={classes.greenButton}
                        >
                          <DeleteIcon color="secondary" />
                        </IconButton>
                      )}
                      {showHiddenRecords && (
                        <IconButton
                          onClick={() => handleOpenDialog(row)}
                          className={classes.greenButton}
                        >
                          <RestorePageIcon color="secondary" />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={Object.values(visibleColumns).filter(Boolean).length + 1} align="center">
                  No hay Proveedores para mostrar
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={visibleRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página"
      />

      <ConfirmDialog
        open={open}
        onClose={handleCloseDialog}
        onConfirm={() =>
          handleGenericUpdate({
            selectedItem: selectedRow,
            data: dataEvents,
            setData: (newData) => {
              setDataEvents(newData);
              setFilteredEvents(newData.filter(row => showHiddenRecords ? row.oculto : !row.oculto));
            },
            apiUpdateFunction: api.proveedores.update,
            idField: "idProveedor",
            updatePayload: showHiddenRecords ? { oculto: false } : { oculto: true },
            closeDialog: handleCloseDialog,
          })
        }
        title={showHiddenRecords ? "Recuperar Registro" : "Ocultar Registro"}
        description={showHiddenRecords ? "¿Está seguro de que quiere recuperar el registro?" : "¿Está seguro de que quiere ocultar el registro?"}
        confirmText={showHiddenRecords ? "Recuperar registro" : "Ocultar registro"}
        cancelText="Cancelar"
        icon={<ErrorOutlineIcon className={classes.errorIcon} />}
        classes={{
          dialogTitle: classes.dialogTitle,
          dialogContent: classes.dialogContent,
          dialogButtons: classes.dialogButtons,
          confirmButton: classes.greenButton,
          cancelButton: classes.greenButton,
          iconWrapper: classes.iconWrapper,
        }}
      />
    </div>
  );
};

export default Proveedores;
